module.exports = __webpack_public_path__ + "static/img/3d打印黑色材料.28ab855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3d打印黑色材料.png
// module id = E7gv
// module chunks = 2